/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_External_Booking_Edit_End_TimeInputs */

const en_admin_external_booking_edit_end_time = /** @type {(inputs: Admin_External_Booking_Edit_End_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`End time`)
};

/** @type {(inputs: Admin_External_Booking_Edit_End_TimeInputs) => LocalizedString} */
const de_admin_external_booking_edit_end_time = en_admin_external_booking_edit_end_time;

/** @type {(inputs: Admin_External_Booking_Edit_End_TimeInputs) => LocalizedString} */
const es_admin_external_booking_edit_end_time = en_admin_external_booking_edit_end_time;

/** @type {(inputs: Admin_External_Booking_Edit_End_TimeInputs) => LocalizedString} */
const fr_admin_external_booking_edit_end_time = en_admin_external_booking_edit_end_time;

/** @type {(inputs: Admin_External_Booking_Edit_End_TimeInputs) => LocalizedString} */
const it_admin_external_booking_edit_end_time = en_admin_external_booking_edit_end_time;

/** @type {(inputs: Admin_External_Booking_Edit_End_TimeInputs) => LocalizedString} */
const pt_br2_admin_external_booking_edit_end_time = en_admin_external_booking_edit_end_time;

/** @type {(inputs: Admin_External_Booking_Edit_End_TimeInputs) => LocalizedString} */
const pl_admin_external_booking_edit_end_time = en_admin_external_booking_edit_end_time;

/** @type {(inputs: Admin_External_Booking_Edit_End_TimeInputs) => LocalizedString} */
const hu_admin_external_booking_edit_end_time = en_admin_external_booking_edit_end_time;

/** @type {(inputs: Admin_External_Booking_Edit_End_TimeInputs) => LocalizedString} */
const ro_admin_external_booking_edit_end_time = en_admin_external_booking_edit_end_time;

/**
* | output |
* | --- |
* | "End time" |
*
* @param {Admin_External_Booking_Edit_End_TimeInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_external_booking_edit_end_time = /** @type {((inputs?: Admin_External_Booking_Edit_End_TimeInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_External_Booking_Edit_End_TimeInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_external_booking_edit_end_time(inputs)
	if (locale === "de") return de_admin_external_booking_edit_end_time(inputs)
	if (locale === "es") return es_admin_external_booking_edit_end_time(inputs)
	if (locale === "fr") return fr_admin_external_booking_edit_end_time(inputs)
	if (locale === "it") return it_admin_external_booking_edit_end_time(inputs)
	if (locale === "pt-BR") return pt_br2_admin_external_booking_edit_end_time(inputs)
	if (locale === "pl") return pl_admin_external_booking_edit_end_time(inputs)
	if (locale === "hu") return hu_admin_external_booking_edit_end_time(inputs)
	return ro_admin_external_booking_edit_end_time(inputs)
});
export { admin_external_booking_edit_end_time as "admin.external_booking_edit.end_time" }